import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import { vazirFont } from './pdfFonts';

const dayTitles = {
  Saturday: 'شنبه',
  Sunday: 'یکشنبه',
  Monday: 'دوشنبه',
  Tuesday: 'سه‌شنبه',
  Wednesday: 'چهارشنبه',
  Thursday: 'پنجشنبه',
  Friday: 'جمعه'
};

const mealTitles = {
  Breakfast: 'صبحانه',
  MorningSnack: 'میان‌وعده صبح',
  Lunch: 'ناهار',
  AfternoonSnack: 'میان‌وعده عصر',
  Dinner: 'شام',
  EveningSnack: 'میان‌وعده شب',
  NightSnack: 'میان‌وعده شب',
  Snacks: 'میان‌وعده'
};

export const generateNutritionPdf = (data) => {
  const doc = new jsPDF('p', 'mm', 'a4');
  doc.addFileToVFS('Vazir.ttf', vazirFont);
  doc.addFont('Vazir.ttf', 'Vazir', 'normal');
  doc.setFont('Vazir');
  doc.setFontSize(14);
  let y = 20;

  doc.text('برنامه تغذیه‌ای شخصی‌سازی‌شده', 105, 15, { align: 'center' });
  y += 10;
  doc.setFontSize(12);
  doc.text(
    `کالری روزانه: ${data.TotalCalories} کیلوکالری | پروتئین: ${data.TotalProteinGrams} گرم | کربوهیدرات: ${data.TotalCarbsGrams} گرم | چربی: ${data.TotalFatGrams} گرم`,
    105,
    y,
    { align: 'center' }
  );
  y += 10;

  data.Days.forEach((day) => {
    const dayName = dayTitles[day.Day] || day.Day;

    //doc.setFontSize(13);
   // doc.text(`📅 ${dayName}`, 190, y, { align: 'right' });
   // y += 8;

    day.Meals.forEach((meal) => {
      const mealTitle = mealTitles[meal.MealType] || meal.MealType;

      doc.setFontSize(12);
      doc.text(`🍽 ${mealTitle}`, 190, y, { align: 'right' });
      y += 6;

      meal.Options.forEach((option, optIdx) => {
        const optionLabel = `گزینه ${optIdx + 1}:`;
        doc.setFontSize(8);
        doc.text(optionLabel, 190, y, { align: 'right' });
        y += 5;

        const rows = option.Items.map((item) => [item.Quantity, item.Name]);

        autoTable(doc, {
          startY: y,
          head: [["مقدار", "نام مواد غذایی"]],
          body: rows,
          styles: {
            font: 'Vazir',
            fontSize: 10,
            halign: 'right'
          },
          headStyles: {
            font: 'Vazir',
            fontStyle: 'normal',
            fontSize: 11,
            halign: 'right',
            textDirection: 'rtl',
            fillColor: [60, 90, 60],
            textColor: 255
          },
          columnStyles: {
            0: { cellWidth: 50 },
            1: { cellWidth: 100 }
          },
          margin: { right: 10, left: 10 },
          didDrawPage: (data) => {
            doc.setFontSize(50);
            doc.setTextColor(180);
            doc.text("mogym.ir", doc.internal.pageSize.getWidth() / 2, doc.internal.pageSize.getHeight() / 2, {
              angle: 45,
              align: 'center'
            });

            doc.setFontSize(10);
            doc.setTextColor(0);
          }
        });

        y = doc.lastAutoTable.finalY + 5;
      });

      if (meal.Supplements?.length > 0) {
        doc.setFontSize(11);
        doc.text(`💊 مکمل‌ها:`, 190, y, { align: 'right' });
        y += 5;

        const suppRows = meal.Supplements.map(s => [s.Quantity, s.Name]);

        autoTable(doc, {
          startY: y,
          head: [["مقدار", "نام مکمل"]],
          body: suppRows,
          styles: {
            font: 'Vazir',
            fontSize: 10,
            halign: 'right'
          },
          headStyles: {
            font: 'Vazir',
            fontStyle: 'normal',
            fontSize: 11,
            halign: 'right',
            textDirection: 'rtl',
            fillColor: [120, 60, 60],
            textColor: 255
          },
          columnStyles: {
            0: { cellWidth: 50 },
            1: { cellWidth: 100 }
          },
          margin: { right: 10, left: 10 }
        });

        y = doc.lastAutoTable.finalY + 8;
      }

      y += 4; // فاصله بعد از هر وعده
    });

    y += 6; // فاصله بین روزها
  });

  doc.save('mogym_nutrition_plan.pdf');
};
